import React, { useState } from 'react'
import {
  Box, Button, FormControl, InputLabel, MenuItem, Select,
} from '@mui/material'
import '../styles/menu.css'
import { useQuery } from '@apollo/client'
import { Link, useLocation, useHistory } from 'react-router-dom'
import CategoriesDnD from '../components/products/CategoriesDnD'
import ProductsTabs from '../components/products/ProductsTabs'
import CustomizationsView from '../components/products/CustomizationsView'
import { CustomizationsProvider } from '../components/products/context/customizations'
import { ProductsProvider } from '../components/products/context/products'
import { CATALOGUES } from '../graphql/products'
import ErrorLoading from '../components/layout/ErrorLoading'
import CenterLoader from '../components/spinners/CenterLoader'

export default function Products() {
  const [activeTab, setActiveTab] = useState('categories')
  const location = useLocation()
  const history = useHistory()
  const [catalogueId, setCatalogueId] = useState(location.state?.catalogueId || null)
  const { loading, error, data } = useQuery(CATALOGUES, {
    fetchPolicy: 'cache-and-network',
    variables: {
      limit: 100,
      offset: 0,
    },
    onCompleted: () => {
      if (!location.state?.catalogueId) {
        if (data.catalogues?.length > 0) {
          setCatalogueId(data.catalogues[0].id)
        } else {
          history.push('/business/catalogues')
        }
      }
    },
  })

  if (loading) return <CenterLoader visible />

  if (error) return <ErrorLoading visible />

  return (
    <ProductsProvider>
      <CustomizationsProvider>
        <Box sx={{ paddingY: 2 }}>
          <Box sx={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2,
          }}
          >
            { catalogueId
              ? (
                <FormControl sx={{ minWidth: '200px' }}>
                  <InputLabel>Products Catalogue</InputLabel>
                  <Select
                    value={catalogueId}
                    label="Products Catalogue"
                    onChange={(e) => { setCatalogueId(e.target.value) }}
                    type="text"
                    size="small"
                  >
                    {data.catalogues?.map((c) => (<MenuItem value={c.id}>{c.title}</MenuItem>))}
                  </Select>
                </FormControl>
              ) : null}
            <Link to="/business/catalogues">
              <Button
                variant="text"
                sx={{
                  textDecoration: 'underline',
                  '&:hover': { textDecoration: 'underline' },
                }}
              >
                Manage Catalogues
              </Button>
            </Link>
          </Box>
          <ProductsTabs value={activeTab} handleChange={(event, newValue) => { setActiveTab(newValue) }} catalogueId={catalogueId} />
          <Box sx={{ paddingX: 1 }}>
            {activeTab === 'categories' ? <CategoriesDnD catalogueId={catalogueId} /> : null}
            {activeTab === 'customizations' ? <CustomizationsView catalogueId={catalogueId} /> : null}
          </Box>
        </Box>
      </CustomizationsProvider>
    </ProductsProvider>
  )
}
